webpackJsonp([3],{

/***/ "EdKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("eo6p");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_535d5e56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nSIH");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("oaz5")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-535d5e56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_535d5e56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/custom/home/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-535d5e56", Component.options)
  } else {
    hotAPI.reload("data-v-535d5e56", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "H3BY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.6215c94.jpg";

/***/ }),

/***/ "J1Ik":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hezuo.c6a5120.jpg";

/***/ }),

/***/ "eo6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__script_js__ = __webpack_require__("mX5n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__script_js__["a" /* default */]);

/***/ }),

/***/ "mX5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {},
  data: function data() {
    return {
      input: ''
    };
  },

  methods: {},
  // 计算属性
  computed: {},
  created: function created() {}
});

/***/ }),

/***/ "nSIH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.isPc
    ? _c("div", { staticClass: "home" }, [_vm._m(0)])
    : _c("div", { staticClass: "home" }, [_vm._m(1)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carousel-item" }, [
      _c("div", { staticClass: "banner" }),
      _vm._v(" "),
      _c("div", { staticClass: "company-introduct" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业简介")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              " 苏州亿数腾云科技有限公司团队成立于2008年，由一批专注于软件和硬件系统集成的行业精英组成。十多年的开发经验，奠定了强大的技术实力。于2018年正式成立科技公司，公司延续了强大的开发能力，并且将优势定位于企业管理类，工业流程类，大数据分析，物联网应用等解决方案。崭新的解决方案已经给数十家客户带来福音。"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              "亿数人秉承不断进取，勇于创新理念，以客户需求为出发点，实实在在的服务好客户。已经在各行各业获得了客户一致好评。\n\t\t\t\t\t\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "company-profile" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业文化")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile" }, [
          _c("div", { staticClass: "width-30 hezuo" }, [
            _c("img", {
              staticClass: "hezuo",
              attrs: { src: __webpack_require__("J1Ik") }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "width-70" }, [
            _c("div", { staticClass: "border div-item" }, [
              _c("p", [
                _vm._v(
                  " 成功靠朋友，成长靠对手，成就靠团队。创意是金钱，策划显业绩，思考才致富。知道是知识，做到才智慧，多做少多说。积极激励我，多劳多收获，汗水育成果。梦想聚团队，团队铸梦想，激情快乐人。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "border div-item" }, [
              _c("p", [
                _vm._v(
                  "快乐让公司环境变得令人愉快点吧。当人们喜欢他们所做的工作，并且乐于与那些一起工作的人共事，他们就会高效率地工作。\n\t\t\t\t\t\t\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "border div-item" }, [
              _c("p", [
                _vm._v(
                  "目标明确，坚定不移，天道酬勤，永续经营。\n\t\t\t\t\t\t\t\t\t\t"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carousel-item" }, [
      _c("div", { staticClass: "banner" }),
      _vm._v(" "),
      _c("div", { staticClass: "company-introduct" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业简介")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              " 苏州亿数腾云科技有限公司团队成立于2008年，由一批专注于软件和硬件系统集成的行业精英组成。十多年的开发经验，奠定了强大的技术实力。于2018年正式成立科技公司，公司延续了强大的开发能力，并且将优势定位于企业管理类，工业流程类，大数据分析，物联网应用等解决方案。崭新的解决方案已经给数十家客户带来福音。"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border div-item" }, [
          _c("p", [
            _vm._v(
              "亿数人秉承不断进取，勇于创新理念，以客户需求为出发点，实实在在的服务好客户。已经在各行各业获得了客户一致好评。\n\t\t\t\t\t\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "company-profile" }, [
        _c("div", { staticClass: "div-item" }, [
          _c("h1", [_vm._v("企业文化")]),
          _vm._v(" "),
          _c("span", { staticClass: "detail" }, [_vm._v("COMPANY PROFILE")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile" }, [
          _c("div", { staticClass: "border div-item" }, [
            _c("p", [
              _vm._v(
                " 成功靠朋友，成长靠对手，成就靠团队。创意是金钱，策划显业绩，思考才致富。知道是知识，做到才智慧，多做少多说。积极激励我，多劳多收获，汗水育成果。梦想聚团队，团队铸梦想，激情快乐人。"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border div-item" }, [
            _c("p", [
              _vm._v(
                "快乐让公司环境变得令人愉快点吧。当人们喜欢他们所做的工作，并且乐于与那些一起工作的人共事，他们就会高效率地工作。\n\t\t\t\t\t\t\t\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border div-item" }, [
            _c("p", [
              _vm._v(
                "目标明确，坚定不移，天道酬勤，永续经营。\n\t\t\t\t\t\t\t\t\t\t"
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-535d5e56", esExports)
  }
}

/***/ }),

/***/ "oaz5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pcAV");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("FIqI")("0f273f4a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/_css-loader@0.28.11@css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-535d5e56\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!../../../../node_modules/_sass-resources-loader@2.2.4@sass-resources-loader/lib/loader.js?{\"resources\":[\"G:\\\\文档\\\\web\\\\yes-cloud-web\\\\src\\\\resource\\\\css\\\\variable\\\\index.scss\"]}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/_css-loader@0.28.11@css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-535d5e56\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!../../../../node_modules/_sass-resources-loader@2.2.4@sass-resources-loader/lib/loader.js?{\"resources\":[\"G:\\\\文档\\\\web\\\\yes-cloud-web\\\\src\\\\resource\\\\css\\\\variable\\\\index.scss\"]}!../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pcAV":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("L4zZ");
exports = module.exports = __webpack_require__("UTlt")(false);
// imports


// module
exports.push([module.i, "\n.theme-base[data-v-535d5e56] {\n  --base: #fff;\n  --base-2: #339AF0;\n  --base-3: #f3f3f3;\n  --base-4: #F1723F;\n  --base-5: #F388AD;\n  --base-6: #B58C71;\n  --base-7: #bcc0c7;\n  --base-8: #597eca;\n  --base-9: #b6c5e4;\n  --base-10: #b53e3e;\n  --base-11: #C3E989;\n  --base-12: #FCC419;\n  --base-13: #676b6d8a;\n  --base-14: #5b7b2b;\n  --base-15: #E9EAEB;\n  --base-16: #27b238;\n  --base-17: #aebcca;\n  --base-18: #7ebf1b;\n  --base-19: #51CF66;\n  --base-20: #28B339;\n  --base-21: rgba(0, 0, 0, 0.4);\n  --base-22: #15185f;\n  --font-color: #2c3e50;\n  --input-color: #81858c;\n}\n.moble-app .theme-base[data-v-535d5e56] {\n  --d-mini-0: 0.1rem;\n  --c-mini-0: 0.15rem;\n  --b-mini-0: 0.18rem;\n  --a-mini-0: 0.2rem;\n  --mini-0: 0.22rem;\n  --mini: 0.25rem;\n  --small-0: 0.28rem;\n  --small: 0.3rem;\n  --small-2: 0.35rem;\n  --default-size: 0.4rem;\n  --big: 0.45rem;\n  --large: 0.5rem;\n  --large-2: 0.6rem;\n  --large-3: 0.7rem;\n  --large-4: 0.8rem;\n  --large-5: 1rem;\n}\n.pc-app .theme-base[data-v-535d5e56] {\n  --mini: 12px;\n  --small: 16px;\n  --large: 26px;\n}\n.pc-app .home .carousel-item[data-v-535d5e56] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column;\n}\n.pc-app .home .carousel-item .banner[data-v-535d5e56] {\n    height: 400px;\n    background-image: url(" + escape(__webpack_require__("H3BY")) + ");\n    width: 100%;\n    background-size: cover;\n}\n.pc-app .home .carousel-item .company-introduct[data-v-535d5e56], .pc-app .home .carousel-item .company-profile[data-v-535d5e56] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: column;\n            flex-flow: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    max-width: 900px;\n    padding: 20px;\n}\n.pc-app .home .carousel-item .company-introduct h1[data-v-535d5e56], .pc-app .home .carousel-item .company-profile h1[data-v-535d5e56] {\n      font-size: var(--large);\n      color: var(--base-10);\n}\n.pc-app .home .carousel-item .company-introduct .detail[data-v-535d5e56], .pc-app .home .carousel-item .company-profile .detail[data-v-535d5e56] {\n      color: var(--base-7);\n}\n.pc-app .home .carousel-item .company-introduct p[data-v-535d5e56], .pc-app .home .carousel-item .company-profile p[data-v-535d5e56] {\n      margin: 0;\n      text-indent: 1.5em;\n      color: var(--font-color);\n      letter-spacing: 1.5px;\n}\n.pc-app .home .carousel-item .company-introduct .div-item[data-v-535d5e56], .pc-app .home .carousel-item .company-profile .div-item[data-v-535d5e56] {\n      padding: 20px;\n}\n.pc-app .home .carousel-item .company-introduct .div-item + .div-item[data-v-535d5e56], .pc-app .home .carousel-item .company-profile .div-item + .div-item[data-v-535d5e56] {\n      margin-top: 20px;\n}\n.pc-app .home .carousel-item .company-introduct .profile[data-v-535d5e56], .pc-app .home .carousel-item .company-profile .profile[data-v-535d5e56] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.pc-app .home .carousel-item .company-introduct .profile .hezuo[data-v-535d5e56], .pc-app .home .carousel-item .company-profile .profile .hezuo[data-v-535d5e56] {\n        padding-right: 20px;\n}\n.pc-app .home .carousel-item .company-introduct .profile .hezuo img[data-v-535d5e56], .pc-app .home .carousel-item .company-profile .profile .hezuo img[data-v-535d5e56] {\n          max-width: 100%;\n}\n.moble-app .home[data-v-535d5e56] {\n  padding-bottom: 1rem;\n}\n.moble-app .home .carousel-item[data-v-535d5e56] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: column;\n            flex-flow: column;\n}\n.moble-app .home .carousel-item .banner[data-v-535d5e56] {\n      height: 3rem;\n      background-image: url(" + escape(__webpack_require__("H3BY")) + ");\n      width: 100%;\n      background-size: cover;\n}\n.moble-app .home .carousel-item .company-introduct[data-v-535d5e56], .moble-app .home .carousel-item .company-profile[data-v-535d5e56] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-flow: column;\n              flex-flow: column;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      max-width: 80%;\n      padding: 0.05rem;\n}\n.moble-app .home .carousel-item .company-introduct h1[data-v-535d5e56], .moble-app .home .carousel-item .company-profile h1[data-v-535d5e56] {\n        padding: 0;\n        margin: 0;\n        font-size: var(--c-mini-0);\n        color: var(--base-10);\n}\n.moble-app .home .carousel-item .company-introduct .detail[data-v-535d5e56], .moble-app .home .carousel-item .company-profile .detail[data-v-535d5e56] {\n        font-size: 0.03rem;\n        color: var(--base-7);\n}\n.moble-app .home .carousel-item .company-introduct p[data-v-535d5e56], .moble-app .home .carousel-item .company-profile p[data-v-535d5e56] {\n        font-size: 0.03rem;\n        margin: 0;\n        text-indent: 1.5em;\n        color: var(--font-color);\n        letter-spacing: 1.5px;\n}\n.moble-app .home .carousel-item .company-introduct .div-item[data-v-535d5e56], .moble-app .home .carousel-item .company-profile .div-item[data-v-535d5e56] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-flow: column;\n                flex-flow: column;\n        padding: 0.01rem;\n}\n.moble-app .home .carousel-item .company-introduct .div-item + .div-item[data-v-535d5e56], .moble-app .home .carousel-item .company-profile .div-item + .div-item[data-v-535d5e56] {\n        margin-top: 20px;\n}\n.moble-app .home .carousel-item .company-introduct .profile[data-v-535d5e56], .moble-app .home .carousel-item .company-profile .profile[data-v-535d5e56] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-flow: column;\n                flex-flow: column;\n}\n.moble-app .home .carousel-item .company-introduct .profile .hezuo[data-v-535d5e56], .moble-app .home .carousel-item .company-profile .profile .hezuo[data-v-535d5e56] {\n          padding-right: 20px;\n}\n.moble-app .home .carousel-item .company-introduct .profile .hezuo img[data-v-535d5e56], .moble-app .home .carousel-item .company-profile .profile .hezuo img[data-v-535d5e56] {\n            max-width: 100%;\n}\n", ""]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.61369be7b0004b3e9900.js